import { configureStore } from "@reduxjs/toolkit";
import indexReducer from "./reducers/indexReducer";
import thunk from "redux-thunk";
import AuthReducer from "./reducers/AuthReducer";
import PermissionReducer from "./reducers/PermissionReducer";
import dashboardReducer from "./reducers/DashboardReducer";
import TicketReducer from "./reducers/TicketReducer";
import SettlementReducer from "./reducers/SettlementReducer";
import InvoiceReducer from "./reducers/InvoiceReducer";
const Store = configureStore({
  reducer: {
    indexReducer,
    AuthReducer,
    PermissionReducer,
    dashboardReducer,
    TicketReducer,
    SettlementReducer,
    InvoiceReducer,
  },
  middleware: [thunk],
});

export default Store;
